const styles = theme => ({
  root: {
    position: 'relative',
    width: '430px',
    marginBottom: theme.spacing(2),
    '& img': {
      width: '100%',
      overflow: 'hidden',
      display: 'block',
      height: '310px',
      objectFit: 'cover',
    },
  },
  overlay: {
    background: 'rgba(51, 51, 51, 0.5)',
    position: 'absolute',
    top: '258px',
    zIndex: 1,
    width: '100%',
    '& > div': {
      padding: theme.spacing(1),
    },
  },
  iframeVideo: {
    maxHeight: '310px',
  },
})

export default styles
